/** Sean’s product emails (manual-balance / bank-account UI scoping). */
export const SEAN_VIEWER_EMAILS = [
  'sean.osullivan@gmail.com',
  'seanosullivan@gmail.com',
] as const;

export function isSeanViewerEmail(email?: string | null): boolean {
  const normalised = (email || '').trim().toLowerCase();
  return (SEAN_VIEWER_EMAILS as readonly string[]).includes(normalised);
}

/** Canonical manual-balance Revolut business accounts (not migration/API placeholders). */
export const SEAN_MANUAL_BANK_ACCOUNT_IDS: readonly number[] = [1, 2];

export function filterBankAccountsForSeanViewer<T extends { id: number }>(
  accounts: T[],
  email?: string | null,
): T[] {
  if (!isSeanViewerEmail(email)) {
    return accounts;
  }
  const allowed = new Set(SEAN_MANUAL_BANK_ACCOUNT_IDS);
  return accounts.filter((account) => allowed.has(account.id));
}
